// Dependencies
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";

// Images
import BannerLogin from "../images2/Banner_login.png";
import logoMarzah from "../images2/logo_header.png";

// Styles
import "../styles/Signup.scss";
import Swal from "sweetalert2";
import { loginClient } from "../services/LoginService";
import useForm from "../hooks/useForm";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FaHome } from "react-icons/fa";

export const Login = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  let dataArray;
  let initialState = {
    fullName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    email: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message:
        "El correo solo puede contener letras, numeros, puntos y guiones.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit } = useForm(
    initialState,
    validations
  );

  const submitForm = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      dataArray = {
        email: formData.email,
        password: formData.password,
      };
      try {
        const response = await loginClient(dataArray);
        localStorage.setItem("dataUser", JSON.stringify(response));
        if (response) {
          Swal.fire({
            imageUrl: logoMarzah,
            title: "Bienvenido a Marzah Travel.",
            text: `Iniciaste sesión exitosamente! ${response?.usuario?.nombre} ${response?.usuario?.apellido}. Aquí podrás encontrar todo lo que necesitas para viajar con nosotros.`,
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#535558ff",
          });
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      } catch (error) {
        console.error("Hubo un error al Iniciar Sesión:", error);
        Swal.fire({
          icon: "error",
          title: "Hubo un error al iniciar sesión.",
          text: "El correo o la contraseña son incorrectos.",
        });
      }
    }
    setValidated(true);
  };

  return (
    <div>
      <img
        src={BannerLogin}
        alt="Banner Sign Up"
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />
      <Form
        className="signup-form needs-validation rounded-4 shadow"
        onSubmit={submitForm}
        // onSubmit={(e) => handleSubmit(e, submitForm)}
        noValidate
        validated={validated}
      >
        <Row className="m-0">
          <Col xs={12}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Ir al Inicio</Tooltip>}
            >
              <Button onClick={() => navigate("/")} variant="secondary">
                <FaHome />
              </Button>
            </OverlayTrigger>
          </Col>
          <Col xs={12} className="text-center">
            <img
              src={
                "https://panel.marzahtravel.com/assets/img/logoHeaderBlanco.png"
              }
              className="w-auto"
              alt=""
            />
          </Col>
          <Col lg={6} md={6} xs={12} className="">
            <Form.Group controlId="formEmail">
              <Form.Label className="text-white">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                isInvalid={
                  validated &&
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                Email inválido.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={12}>
            <Form.Group controlId="formPassword">
              <Form.Label className="text-white">Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                isInvalid={validated && formData.password.length < 6}
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese una contraseña válida.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={12} md={12} sm={12} className="">
            <div className="d-flex justify-content-between">
              <p className="text-white mt-2">
                Aun no tengo una cuenta.{" "}
                <Link className="text-white" to="/signup">
                  Regístrate aquí
                </Link>
              </p>
              <p className="text-white mt-2">
                <Link className="text-white" to="/resend-email">
                  ¿Olvidaste tu contraseña?
                </Link>
              </p>
            </div>
            <Form.Group controlId="formSubmit" className="text-end">
              <Form.Label></Form.Label>
              <Button className="btn-register" type="submit">
                Iniciar Sesión
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
